<form #offerForm="ngForm">
  <div class="row">
    <div class="col-12">
      <div class="formCotainer">
        <h2>{{model.applicantName}}</h2>
        <div class="formBody pt-2">
          <div class="row">
            <div class="col-12">
              <p>We are pleased to inform you that you have been selected for employment. Please review the job offer contained in the email, select the appropriate option, and provide your comments in the text box.</p>
            </div>
          </div>

          <div class="row" style="margin-bottom: -10px;" *ngIf="model.canSign || model.hasSigned">
            <div class="col-12">
              <button *ngIf="!model.hasSigned" class="btn btn-primary" mdbWavesEffect (click)="loadPdfRenderer()" [disabled]="startingStatus === 'Revoked'">View and Sign Offer Letter</button>
              <div *ngIf="model.hasSigned" class="alert alert-primary">Your Offer Letter is signed. Please add a comment below and click Send to finalize this process.</div>
            </div>
          </div>

          <div class="row mt-3 mb-2">
            <div class="col-12">
              <input mdbInput type="radio" class="form-check-input" id="acceptOffer" name="offerStatus"
                     required [(ngModel)]="model.offer.status" [value]="'Accepted'" [disabled]="hasSubmitted || startingStatus === 'Revoked'"
                     data-success=" " *ngIf="!model.clientId || model.hasSigned">
              <label class="form-check-label" for="acceptOffer" *ngIf="!model.clientId || model.hasSigned">I Accept This Offer</label><br>
              <input mdbInput type="radio" class="form-check-input" id="rejectOffer" name="offerStatus"
                     required [(ngModel)]="model.offer.status" [value]="'Rejected'" [disabled]="hasSubmitted || startingStatus === 'Revoked'"
                     data-success=" ">
              <label class="form-check-label" for="rejectOffer">I Decline This Offer</label>
            </div>
          </div>
          <div class="row mt-3 mb-2">
            <div class="col-12">
              <div class="commentContainer">
                <label for="applicantComment">Add Comment<span class="text-danger">*</span></label>
                <ckeditor name="applicantComment" required [config]="editorConfig" [editor]="Editor" [(ngModel)]="model.offer.message.content" [disabled]="hasSubmitted || startingStatus === 'Revoked'"></ckeditor>
                <app-attachments *ngIf="startingStatus !== 'Revoked'"
                  [(attachments)]="model.offer.message.attachments"
                  [supportedFileTypes]="supportedFileTypes"
                  [maxFileSize]="maxFileSize"
                  [maxCumulativeFileSize]="maxCumulativeFileSize"
                  [saveRoute]="saveAttachmentRoute"
                  [isRequired]="false"></app-attachments>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12 text-right">
      <button
              class="btn btn-primary"
              mdbWavesEffect
              [disabled]="(!offerForm.form.valid && !hasSubmitted) || (model.clientId && !model.hasSigned && model.offer.status !== 'Rejected') || startingStatus === 'Revoked'"
              (click)="save()">Send</button>
    </div>
  </div>
</form>


<div mdbModal #thankYouModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="thankYouModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Thank you</h4>
      </div>
      <div class="modal-body" *ngIf="submittedPrior">Your response to this request has already been received.</div>
      <div class="modal-body" *ngIf="!submittedPrior">Your submission has been received.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="Close" (click)="thankYouModal.hide()" mdbWavesEffect>Ok</button>
      </div>
    </div>
  </div>
</div>

<div mdbModal #offerRevokedModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="offerRevokedModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Offer Revoked</h4>
      </div>
      <div class="modal-body">This offer is no longer valid.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="Close" (click)="offerRevokedModal.hide()" mdbWavesEffect>Ok</button>
      </div>
    </div>
  </div>
</div>
